import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import {  Link, useLocation } from "react-router-dom";

import { Img } from "../../../components/Elements";
import { AppContext } from "../../../Context";

import { MdQuestionAnswer, MdEdit, MdOutlineMoreVert, MdOutlineDeleteOutline, MdOutlineContentCopy } from "react-icons/md";
import { permissions } from '../../../inc/Fetch';

export default function AudioList({ v }) {

    const { t } = useTranslation();
    const location = useLocation();

    const regex = /(<([^>]+)>)/gi;
    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    
    var cleanText = v?.full.replace(/&nbsp;/g,' ');

    return (
        <Link to={userinfo?._id ? `/audio/${v?._id}` : '/login'} state={!userinfo?._id ? { previousLocation: location } : false} className='audioList'>

            <Img src={`img/230x150/${v?.img[0]}`} />
            <h5>{v?.title}</h5>
            <p>{cleanText?.replace(regex, " ")?.substring(0, 100)}</p>

            <ul>
                <li className='tag orange'>{t("class")} {global?.Classes[v?.classes[0]]}</li>
                <li className='tag'>{v?.subject?.name}</li>
            </ul>
        </Link>
    )
}
